export default __webpack_public_path__ + "static/media/boleta.71810b4b.png";